module.exports = __webpack_public_path__ + "img/3.3c18e060.jpg";